module.exports = __webpack_public_path__ + "media/images/career_camp/2022/dividers/motto_mountains-c0e95e4c7409bd081d615cb515f1b547.svg";